var map = {
	"./deadline-in-progress.svg": "6dd1",
	"./deadline-valid.svg": "1912",
	"./deadline-warning.svg": "446d",
	"./pdca-act.svg": "73d3",
	"./pdca-check.svg": "e8a5",
	"./pdca-do.svg": "8623",
	"./pdca-pending.svg": "9762",
	"./pdca-plan.svg": "3272"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";